import ImgSmile from "../assets/smile.png";
import ImgMeh   from "../assets/meh.png";
import ImgFrown from "../assets/frown.png";

// Las tres respuestas de ánimo del Weekly Form, con el icono del diseño.
export const MOOD_ICONS = {
  cooperative:   ImgSmile,
  neutral:       ImgMeh,
  uncomfortable: ImgFrown,
};
